import { render, staticRenderFns } from "./pandaGloryMerchantMenuList.vue?vue&type=template&id=18644ab2&scoped=true"
import script from "./pandaGloryMerchantMenuList.vue?vue&type=script&lang=ts"
export * from "./pandaGloryMerchantMenuList.vue?vue&type=script&lang=ts"
import style0 from "./pandaGloryMerchantMenuList.vue?vue&type=style&index=0&id=18644ab2&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18644ab2",
  null
  
)

export default component.exports